import {withStyles} from "@mui/styles";
import axios from 'axios';
import * as React from "react";
import {Config} from '../../config/config';
import {Helpers} from '../../utils/helpers';
import {PopupMessage} from "../../utils/message";
import {Button, Grid, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';

// Green: '✔'
const TICK = <span style={{color: 'green'}}>✔</span>;
// Red: '✘'
const CROSS = <span style={{color: 'red'}}>✘</span>;

const Booleans = [
    {label: 'All', value: 'All'},
    {label: 'True', value: 'true'},
    {label: 'False', value: 'false'},
];

const types = [
    {label: 'All', value: 'All'},
    {label: 'COMPETITION', value: 'COMPETITION'},
    {label: 'LUCKY_WHEEL', value: 'LUCKY_WHEEL'},
]

class PlayerMailMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            filter: {
                type: 'All',
                is_read: 'All',
                is_claimed: 'All',
                offset: 0,
                limit: 50,
            },
            userId: this.props.playerId,
            mails: [],
            loading: false,
        };
    }

    componentDidMount(): void {
        this.fetchData();
    }

    async fetchData() {
        const userId = this.state.userId;
        const url = `${Config.getInstance.apiUrl}/api/user/${userId}/mails`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const {filter} = this.state;

        this.setState({
            loading: true,
        });

        const response = await axios.get(url, {params: filter, headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const data = response.data;
            const mails = data.mails;

            this.setState({mails});
        } else {
            PopupMessage.error(`Error: ${response.data.message}`)

        }
    }

    onChangeFilter = (key: string, value: any) => {
        const {filter} = this.state;
        filter[key] = value;
        this.setState({filter});
    }

    renderPopup(content) {
        return PopupMessage.success(content);
    }

    renderContent() {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        const mails = this.state.mails;

        return <div style={{overflowX: 'auto', maxWidth: '100%'}}>
            <Table sx={{minWidth: 650}}>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>ID</TableCell>
                        <TableCell>From</TableCell>
                        <TableCell>Subject</TableCell>
                        <TableCell>Message</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>isRead</TableCell>
                        <TableCell>isClaimed</TableCell>
                        <TableCell>Attachment</TableCell>
                        <TableCell>Params</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        mails.map((mail: any, index: number) => {
                            return <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{mail.id}</TableCell>
                                <TableCell>{mail.sender_id}</TableCell>
                                <TableCell>{JSON.stringify(mail.subject)}</TableCell>
                                <TableCell>{JSON.stringify(mail.content)}</TableCell>
                                <TableCell>{mail.type}</TableCell>
                                <TableCell>{mail.is_read ? TICK : CROSS}</TableCell>
                                <TableCell>{mail.is_claimed ? TICK : CROSS}</TableCell>
                                <TableCell>
                                    <Button onClick={() => this.renderPopup(JSON.stringify(mail.attachment))}>
                                        <VisibilityIcon />
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button onClick={() => this.renderPopup(JSON.stringify(mail.params))}>
                                        <VisibilityIcon />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </div>
    }

    renderFilter() {
        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const {filter} = this.state;

        return <Paper style={style}>
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={2}>
                        <TextField
                            label="Type..."
                            select
                            value={filter.type}
                            onChange={(e) => this.onChangeFilter('type', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                            {
                                types.map((type, index) => {
                                    return <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            label="isRead..."
                            select
                            value={filter.is_read}
                            onChange={(e) => this.onChangeFilter('is_read', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                            {
                                Booleans.map((type, index) => {
                                    return <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            label="isClaimed..."
                            select
                            value={filter.is_claimed}
                            onChange={(e) => this.onChangeFilter('is_claimed', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                            {
                                Booleans.map((type, index) => {
                                    return <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <TextField
                            label="Limit..."
                            value={filter.limit}
                            onChange={(e) => this.onChangeFilter('limit', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid>
                    <Grid item sm={1}>
                        <TextField
                            label="Offset..."
                            value={filter.offset}
                            onChange={(e) => this.onChangeFilter('offset', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid>

                    <Grid item sm={1}>
                        <Button disableElevation fullWidth variant="contained" color="primary" onClick={() => this.fetchData()}>Search</Button>
                    </Grid>

                </Grid>
            </Grid>
        </Paper>
    }

    render() {
        const {classes} = this.props;
        return <Paper>
            <Typography className={classes.paper} variant="h6">{`Mails for UID: ${this.state.userId}`}</Typography>
            {this.renderFilter()}
            {this.renderContent()}
        </Paper>
    }
}

const styles: any = () => ({
    paper: {
        padding: 0,
        backgroundColor: "black"
    },
});
export const PlayerMail = withStyles(styles)(PlayerMailMain);
